export const SITE_ORIGIN = (
  (import.meta.env.VITE_SITE_URL as string) || "https://allchinabuyspread.link"
).replace(/\/$/, "");

export const SITE_NAME = "AllChinaBuy Spreadsheet";

export const SITE_DESCRIPTION =
  "Independent AllChinaBuy Spreadsheet resource: organized product categories, seller guides, QC tips, shipping info, reviews and buying tutorials — all in one place.";

export const HOME_TITLE = "AllChinaBuy Spreadsheet — Products, Sellers & Buying Guides";

export const HOME_KEYWORDS =
  "AllChinaBuy Spreadsheet, AllChinaBuy review, AllChinaBuy shipping, AllChinaBuy coupon, China buying agent";

export const ARTICLE_KEYWORDS =
  "AllChinaBuy Spreadsheet, AllChinaBuy guide, AllChinaBuy review, China buying agent";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png";